import React, { useState } from 'react';
import { Trophy, TrendingUp, RotateCcw, Zap, Calendar } from 'lucide-react';
import { Tabs } from '../../components/ui/Tabs';
import { CategoryCard } from '../../components/halloffame/CategoryCard';
import { MemberCard } from '../../components/halloffame/MemberCard';
import { motion, AnimatePresence } from 'framer-motion';
export function StudentHallOfFame() {
  const [activeTab, setActiveTab] = useState('monthly');
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const categories = [{
    id: 'consistency',
    title: 'Constância',
    icon: Calendar,
    description: 'Quem treinou mais dias seguidos',
    color: 'bg-blue-500'
  }, {
    id: 'evolution',
    title: 'Evolução',
    icon: TrendingUp,
    description: 'Maior progresso de carga/medidas',
    color: 'bg-green-500'
  }, {
    id: 'return',
    title: 'Retorno',
    icon: RotateCcw,
    description: 'Voltou com tudo após pausa',
    color: 'bg-purple-500'
  }, {
    id: 'performance',
    title: 'Performance',
    icon: Zap,
    description: 'Melhor desempenho nos treinos',
    color: 'bg-yellow-500'
  }];
  const mockWinners = [{
    rank: 1,
    name: 'Mariana Costa',
    metric: '28',
    metricLabel: 'Dias',
    avatarUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
  }, {
    rank: 2,
    name: 'João Silva',
    metric: '26',
    metricLabel: 'Dias',
    isAnonymous: true
  }, {
    rank: 3,
    name: 'Pedro Santos',
    metric: '25',
    metricLabel: 'Dias',
    avatarUrl: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
  }, {
    rank: 4,
    name: 'Carla Dias',
    metric: '22',
    metricLabel: 'Dias',
    avatarUrl: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
  }, {
    rank: 5,
    name: 'Lucas Oliveira',
    metric: '20',
    metricLabel: 'Dias',
    avatarUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
  }];
  return <div className="space-y-6 pb-24 md:pb-0" data-id="element-447">
      <header data-id="element-448">
        <h1 className="text-2xl font-bold text-[var(--secondary)] mb-2" data-id="element-449">
          Hall da Fama
        </h1>
        <p className="text-gray-500 text-sm" data-id="element-450">
          Reconhecimento para quem se esforça.
        </p>
      </header>

      <Tabs tabs={[{
      id: 'monthly',
      label: 'Mensal'
    }, {
      id: 'alltime',
      label: 'Recordes'
    }]} activeTab={activeTab} onChange={setActiveTab} data-id="element-451" />

      {/* Categories Grid */}
      <div className="grid grid-cols-2 gap-3" data-id="element-452">
        {categories.map(cat => <div key={cat.id} className="aspect-[4/3]" data-id="element-453">
            <CategoryCard {...cat} onClick={() => setSelectedCategory(selectedCategory === cat.id ? null : cat.id)} data-id="element-454" />
          </div>)}
      </div>

      {/* Winners List Section */}
      <div className="mt-8" data-id="element-455">
        <div className="flex items-center justify-between mb-4" data-id="element-456">
          <h3 className="font-bold text-lg text-gray-800" data-id="element-457">
            {selectedCategory ? categories.find(c => c.id === selectedCategory)?.title : 'Destaques em Constância'}
          </h3>
          <span className="text-xs font-medium text-gray-400 bg-gray-100 px-2 py-1 rounded" data-id="element-458">
            Outubro/2023
          </span>
        </div>

        <AnimatePresence mode="wait" data-id="element-459">
          <motion.div key={selectedCategory || 'default'} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.3
        }} data-id="element-460">
            {mockWinners.map(winner => <MemberCard key={winner.rank} {...winner} data-id="element-461" />)}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>;
}